import React from 'react';
import Reveal from './Reveal';

export default function SectionHeading({
  eyebrow,
  title,
  subtitle,
  light = false,
  className = '',
}) {
  return (
    <Reveal className={className}>
      <div className={`section-eyebrow ${light ? 'light' : ''}`}>{eyebrow}</div>
      <h2 className="section-title">{title}</h2>
      {subtitle ? <p className={`section-subtitle ${light ? 'light' : ''}`}>{subtitle}</p> : null}
    </Reveal>
  );
}
